import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { SettingsPage } from './SettingsPage';

/** Platform settings: trial and grace for new shops. */
export const routes: FeatureRoute[] = [
  {
    path: 'settings',
    element: (
      <RequireCapability anyOf={['tenants.view']} what="platform settings">
        <SettingsPage />
      </RequireCapability>
    ),
  },
];
